import { createMuiTheme } from "@material-ui/core/styles";

export const theme = {
  primary: "#04435E",
  primaryLight: "#005b7b",
  primaryXLight: "#9FD6DC",
  primaryXXLight: "#b3eff5",
  primaryDark: "#032A3B",
  primaryTransparent: function(opacity) {
    return `rgba(4, 67, 94, ${opacity})`;
  },
  blueLight: "#54c2f9",
  blueDark: "#2c6c90",
  secondary: "#F29F5C",
  tertiary: "#BCDADB",
  tertiaryDark: "#d68c54",
  light: "#F7F7F7",
  white: "#FFFFFF",
  greyLight: "#D8D8D8",
  grey: "#545454",
  black: "#000000",
  positive: "#69bf75",
  neutral: "#e7bd3f",
  negative: "#d95f63",
};

export const muiTheme = createMuiTheme({
  palette: {
    primary: {
      light: theme.primaryLight,
      main: theme.primary,
      dark: theme.primaryDark,
      contrastText: theme.white,
    },
    secondary: {
      light: theme.secondaryLight,
      main: theme.secondary,
      dark: theme.secondaryDark,
      contrastText: theme.white,
    },
  },
});

export const muiThemeWhite = createMuiTheme({
  palette: {
    primary: {
      light: theme.white,
      main: theme.white,
      dark: theme.xxxLight,
      contrastText: theme.black,
    },
  },
});



// WEBPACK FOOTER //
// ./src/modules/theme.js